export default __webpack_public_path__ + "static/media/Stryker_LateralIzq.1e06804f.webp";